<mat-form-field 
    [subscriptSizing]="'dynamic'"
    class="fuse-mat-dense w-full"
    floatLabel="always"
    [matTooltip]="'Filter by Membership ID'"
>
    <mat-select 
        [(value)]="selectedMember" 
        (selectionChange)="onMembershipChange($event.value)"
        placeholder="Membership ID"
        class="whitespace-nowrap"
    >
        <mat-select-trigger>
            <span class="whitespace-nowrap leading-4">{{ getSelectedDisplay() }}</span>
        </mat-select-trigger>
        @for(member of membershipId; track member.membershipId) {
            <mat-option [value]="member.membershipId" class="leading-4 tracking-tighter whitespace-nowrap">
                {{ formattMsisdnView(member.msisdn) }} ({{ member.membershipId }})
            </mat-option>
        }
    </mat-select>
</mat-form-field>
